import { useCurrentUserFeatures } from '../../shared/currentUser';

export const useSubscribeFeature = () => {
  const features = useCurrentUserFeatures();
  return features['s4a-pro-pay'] === 'Rollout';
};
